
import FooterLanding from "../fragments/landing/FooterLanding";
import HeaderLanding from "../fragments/landing/HeaderLanding";

export default function RootAdmin({ children }) {
    return (
        <>
            {/* Lewati ke konten utama — wajib per checklist aksesibilitas design system */}
            <a href="#main-content" className="skip">Lewati ke konten utama</a>

            <HeaderLanding />
            <main id="main-content" className="bg-default">
                { children }
            </main>
            <FooterLanding />
        </>
    )
};
